export default "__VITE_ASSET__jqysOrP2__$_?nuxt_component=async&nuxt_component_name=SvgoHomeSettlementIcon&nuxt_component_export=default__"